import moment from "moment-timezone";

export const DEFAULT_COMPANY_TIMEZONE = "America/Sao_Paulo";

export const COMPANY_TIMEZONE_OPTIONS = [
  { value: "America/Sao_Paulo", label: "São Paulo (UTC-03:00)" },
  { value: "America/Porto_Velho", label: "Porto Velho (UTC-04:00)" },
  { value: "America/Manaus", label: "Manaus (UTC-04:00)" },
  { value: "America/Cuiaba", label: "Cuiabá (UTC-04:00)" },
  { value: "America/Boa_Vista", label: "Boa Vista (UTC-04:00)" },
  { value: "America/Rio_Branco", label: "Rio Branco (UTC-05:00)" },
  { value: "UTC", label: "UTC" }
];

export const resolveCompanyTimezone = (timezone) => (
  timezone && moment.tz.zone(timezone) ? timezone : DEFAULT_COMPANY_TIMEZONE
);

export const getStoredCompanyTimezone = () => {
  try {
    return resolveCompanyTimezone(localStorage.getItem("companyTimezone"));
  } catch (_) {
    return DEFAULT_COMPANY_TIMEZONE;
  }
};

export const formatCompanyDate = (date, timezone) => {
  if (!date) return "—";
  return moment.utc(date).tz(resolveCompanyTimezone(timezone)).format("DD/MM/YYYY");
};

export const formatCompanyDateTime = (date, timezone) => {
  if (!date) return "—";
  return moment.utc(date).tz(resolveCompanyTimezone(timezone)).format("DD/MM/YYYY HH:mm");
};

export const formatCompanyTime = (date, timezone) => {
  if (!date) return "—";
  return moment.utc(date).tz(resolveCompanyTimezone(timezone)).format("HH:mm");
};

export const getCompanyToday = (timezone) => (
  moment().tz(resolveCompanyTimezone(timezone)).format("YYYY-MM-DD")
);

export const getCompanyDateRange = (timezone, range = "today") => {
  const base = moment().tz(resolveCompanyTimezone(timezone));
  let start = base.clone();
  let end = base.clone();

  switch (range) {
    case "yesterday":
      start = base.clone().subtract(1, "day").startOf("day");
      end = base.clone().subtract(1, "day").endOf("day");
      break;
    case "last7days":
      start = base.clone().subtract(6, "days").startOf("day");
      end = base.clone().endOf("day");
      break;
    case "last30days":
      start = base.clone().subtract(29, "days").startOf("day");
      end = base.clone().endOf("day");
      break;
    case "thisMonth":
      start = base.clone().startOf("month");
      end = base.clone().endOf("month");
      break;
    case "today":
    default:
      start = base.clone().startOf("day");
      end = base.clone().endOf("day");
      break;
  }

  return {
    startDate: start.format("YYYY-MM-DD"),
    endDate: end.format("YYYY-MM-DD")
  };
};

export const toCompanyInputDateTime = (utcDate, timezone) => {
  if (!utcDate) return "";
  const parsed = moment.utc(utcDate);
  if (!parsed.isValid()) return "";
  return parsed.tz(resolveCompanyTimezone(timezone)).format("YYYY-MM-DDTHH:mm");
};

export const companyLocalDateTimeToUtcIso = (localDateTime, timezone) => {
  if (!localDateTime) return null;
  const parsed = moment.tz(localDateTime, "YYYY-MM-DDTHH:mm", resolveCompanyTimezone(timezone));
  return parsed.isValid() ? parsed.utc().toISOString() : null;
};
